import { Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import StoryContext from '../../contexts/StoryContext';
import FiltersContext from '../../contexts/FiltersContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
import ProvidersByQualityRating from './ProvidersByQualityRating';
import ProvidersChangeQualityRating from './ProvidersChangeQualityRating';
import ErrorBoundary from '../ErrorBoundary';
import ToggleBy from './ToggleBy';

function StoryQ3() {
  const { lightColor, darkColor } = useContext(StoryContext);
  const [displayBy, setDisplayBy] = useState('Providers');

  const classes = makeStyles(() => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <FiltersContext.Provider value={{
        displayBy,
        setDisplayBy,
      }}
      >
        <Grid
          spacing={2}
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
              How did the pandemic affect the supply of high-quality child care providers?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ToggleBy />
          </Grid>
          <Grid item xs={10} sm={7}>
            <MessageBox>
              <Typography variant="body1" align="left">
                <ErrorBoundary>
                  <ProvidersChangeQualityRating />
                </ErrorBoundary>
              </Typography>
            </MessageBox>
          </Grid>

          <Grid item xs={12} align="center">
            <ErrorBoundary>
              <ProvidersByQualityRating height={400} />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </FiltersContext.Provider>
    </SubquestionBox>
  );
}

export default StoryQ3;
